var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.49414 2.67676H15.5059C16.3297 2.67676 17 3.34703 17 4.1709V12.8297C17 13.6535 16.3297 14.3238 15.5059 14.3238H1.49414C0.670271 14.3238 0 13.6535 0 12.8297V4.1709C0 3.34703 0.670271 2.67676 1.49414 2.67676ZM1.68914 3.67285L1.88856 3.8389L7.90719 8.85061C8.25071 9.13663 8.74936 9.13663 9.09281 8.85061L15.1114 3.8389L15.3109 3.67285H1.68914ZM16.0039 4.39196L11.1001 8.47539L16.0039 11.739V4.39196ZM1.49414 13.3277H15.5059C15.7465 13.3277 15.9478 13.1561 15.9939 12.9289L10.3014 9.14041L9.73018 9.61608C9.37377 9.91285 8.93685 10.0612 8.49997 10.0612C8.06308 10.0612 7.62619 9.91285 7.26976 9.61608L6.69853 9.14041L1.00605 12.9289C1.05221 13.1562 1.25348 13.3277 1.49414 13.3277ZM0.996094 11.739L5.89993 8.47542L0.996094 4.39196V11.739Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.b5d4a1aa9fcd33d243998f402e7457f9.svg";
export { ForwardRef as ReactComponent };